import ArrowBack from "../assets/img/HumQadamHome/arrowBack.svg";

/**
 * Consistent top-left back control (below Header) across web app screens.
 * Min 44×44px touch target for mobile.
 */
function PageBackButton({ onClick, className = "", label = "Go back" }) {
  return (
    <button
      type="button"
      onClick={onClick}
      aria-label={label}
      className={`inline-flex items-center justify-center min-w-[44px] min-h-[44px] self-start ml-2 mt-1 mb-1 p-2 rounded-lg border-0 bg-transparent cursor-pointer touch-manipulation ${className}`.trim()}
    >
      <img src={ArrowBack} alt="" className="w-6 h-6 pointer-events-none" />
    </button>
  );
}

export default PageBackButton;
